import { gql } from '@apollo/client'

const UPDATE_FOOD_MOOD_RELATIONS_DETAILS_MUTATION = gql`
  mutation updateFoodMoodRelationsDetails(
    $id: ID!
    $data: FoodMoodRelationsDetailsInput!
  ) {
    updateFoodMoodRelationsDetails(id: $id, data: $data) {
      id
      updatedAt

      updatedBy {
        id
        name
      }

      dishTypes {
        id
      }
    }
  }
`

export default UPDATE_FOOD_MOOD_RELATIONS_DETAILS_MUTATION
